import { trigger } from './events';
import { findByMatchingProperties } from './array';

/**
 * intitiate crosslink configuration data
 */
let crosslinkDetails = {
    targets: [
        { condition: { type: 'AthleteProfile' } },
        { condition: { type: 'AthleteProfileLite' } },
        { condition: { type: 'ImageWithDropdown' } },
        { condition: { type: 'SwitchableModules' },
            targets: [
                { condition: { type: 'AthleteProfile'} },
                { condition: { type: 'AthleteProfileLite' } },
                { condition: { type: 'ImageWithDropdown' } },
            ]
        },
    ],
};

/**
 * enrich details data with dynamic values, eg.
 *   key: 'initiateWithAthleteId'
 *   value: athlete.id
 *
 * @param key
 * @param value
 * @param data
 * @returns object
 */
const enrichCrosslinkConfigs = (key, value, data) => {
    data.targets.map(item => {
        if (!(item.hasOwnProperty('config') && item.config.hasOwnProperty('initiateWithAthleteId'))) {
            item.config = { 'initiateWithAthleteId': -1 }
        }
        if (item.config.hasOwnProperty(key)) {
            item.config[key] = value;
        }
        return item;
    });
    return data;
}

/**
 * emit event to switch component.
 *
 * 'condition' filters the modules, first match. conditions can have multiple key-value-pairs, eg
 *    condition: { type: 'AthleteProfile', showRadar: false },
 * 'config' overwrites the matching config, eg
 *    config: { initiateWithAthleteId: athlete.id },
 * .
 *
 * @param e
 * @param id
 * @param data
 */
const handleClickAthleteName = (e, id, data = crosslinkDetails) => {
    data = data || crosslinkDetails;
    trigger('switchComponent',
        enrichCrosslinkConfigs('initiateWithAthleteId', id, data)
    );
};

/**
 * set pointer class only if at least one crosslink condition matches
 *
 * @param context
 * @param data
 * @returns {string}
 */
const getCrosslinkClass = (context, data) => {
    data = data || crosslinkDetails;
    let result = '';
    if (data && data.targets) {
        data.targets.map((_module) => {
            if (findByMatchingProperties(context.config.modules, _module.condition).length) {
                result = 'pointer';
            }
            return true;
        });
    }
    return result;
}

/**
 * pool can be entrants, select options or others
 *
 * @param pool
 * @param id
 * @returns {*}
 */
const getAthleteById = (pool, id) =>
  Array.isArray(pool) && (
    (pool[0].hasOwnProperty('athlete_id') && pool.find((athlete) => athlete.athlete_id === id)) ||
    (pool[0].hasOwnProperty('athlete') && pool[0].athlete.hasOwnProperty('id') && pool.find((athlete) => athlete.athlete.id === id))
  );

/**
 * pool can be entrants, select options or others
 *
 * @param pool
 * @param id
 * @returns {*}
 */
const getAthleteIdById = (pool, id) => {
    // search flat and nested items
    const athlete = getAthleteById(pool, id);
    if (athlete) {
        // "glob" the right id, expecting the existence of a matching one
        return athlete.hasOwnProperty('athlete') ? athlete.athlete.id : athlete.athlete_id
    }
}

export { handleClickAthleteName, getCrosslinkClass, enrichCrosslinkConfigs, getAthleteById, getAthleteIdById }